import React from "react";
import ReactPannellum, { getConfig } from "react-pannellum";
import { useNavigate } from "react-router";
import ThreeSixtyIcon from '@mui/icons-material/ThreeSixty';
import { Button } from "@mui/material";

const ReactPanallumVr = ({ image, idx }) => {
  // Log the image name (if image exists)


  const config = {
    autoRotate: -2,
    autoLoad: true,
    loaded: () => console.log("Panorama loaded"),
    error: (errorMsg) => console.error("Panorama error:", errorMsg)
  };

  const navigate = useNavigate();

  const handleClick = (imageData) => {
    navigate("/vr-image", { state: imageData });
  };

  // Determine correct image source (supports API records { image, title }
  // as well as the legacy static { img, name } shape)
  const imageSource = image?.image || image?.img || image;
  const sceneName = image?.title || image?.name || 'panorama';

  return (
    <div style={{position:"relative"}}>
      <ReactPannellum
        id={`panorama-${idx}`}
        sceneId={`scene-${sceneName}-${idx}`}
        imageSource={imageSource}
        config={config}
        style={{
            height: "400px",
            background: "#000000"
          }}
      />
           <Button
        onClick={()=>handleClick(image)}
        sx={{
          position: "absolute",
          top: "10px",
          right: "10px",
          zIndex: 1,
          padding: "10px",
          // background: "#007bff",
          // color: "#fff",
          
          backgroundColor: '#121212',
          color:"white",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
        }}
        startIcon={<ThreeSixtyIcon />}
      >
        360 
      </Button>
    </div>
  );
};

export default ReactPanallumVr;
